import { WSInfoBox } from "@wingspanhq/fe-component-library";
import React from "react";
import { BulkActionType } from "../types";

type Props = {
  actionName: string;
  actionType: BulkActionType;
};

export const BulkActionReminder: React.FC<Props> = props =>
  props.actionType === "foreground" ? (
    <WSInfoBox>
      <b>Reminder:</b> Please keep this window open until complete.
    </WSInfoBox>
  ) : (
    <WSInfoBox>
      <b>Reminder:</b> The {props.actionName.toLowerCase()} will run in the
      background. You can continue using Wingspan and we'll notify you when it's
      complete.
    </WSInfoBox>
  );
